<template>
    <v-dialog v-model="d" width="30%" persistent>
        <v-card>
            <v-card-title>Archive Technician</v-card-title>
            <v-card-text>
                Are you sure you want to archive {{active.name}}?
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="error" @click="archiveTechnician">Archive Technician</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex";
    import {ValetHttp} from "../../http/ValetHttp";

    export default {
        name: "DeleteTechnicianModal",
        data() {
            return {
                isLoading: false
            }
        },
        computed: {
            ...mapState("technicians", ["deleteTechDialog", "activeTech"]),
            d: {
                get() {
                    return this.deleteTechDialog;
                }
            },
            active: {
                get() {
                    return this.activeTech;
                }
            }
        },
        methods: {
            ...mapActions("technicians", ["setActiveTechnician", "setManageDeleteTechnicianDialog", "setTechnicians"]),
            ...mapMutations("app", ["setToast"]),
            async closeDialog() {
                await this.setActiveTechnician({});
                await this.setManageDeleteTechnicianDialog(false);
            },
            async archiveTechnician() {
                try {
                    this.isLoading = true;
                    await ValetHttp.archiveTechnician(this.active._id);
                    this.setToast({color: 'success', text: 'Technician archived successfully', show: true});
                    await this.setTechnicians();
                    await this.setActiveTechnician({});
                    await this.setManageDeleteTechnicianDialog(false);
                } catch (err) {
                    this.setToast({color: 'error', text: err.response.data, show: true})
                } finally {
                    this.isLoading = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
